export default [{
  path: '/login',
  name: 'login',
  component: () => import('@/views/login/index')
}, {
  path: '/token',
  name: 'token',
  component: () => import('@/views/login/token')
}];
